<template>
  <input
    type="file"
    id="files"
    ref="files"
    accept="video/mp4, video/x-m4v, image/*, video/*"
    multiple
    @change="handleFileUploads"
    style="display: none"
  />
</template>

<script>
export default {
  methods: {
    handleFileUploads() {
      this.$emit('change')
    },
    click() {
      this.$refs.files.click()
    },
    getFiles() {
      return this.$refs.files.files
    }
  }
}
</script>

<style></style>
